/** Bounds service requests so the export controls can recover from a stalled connection. */
export async function videoFetch(path: string, options?: RequestInit): Promise<Response> {
  try {
    const deadline = AbortSignal.timeout(15_000);
    return await fetch(path, { ...options, signal: options?.signal ? AbortSignal.any([options.signal, deadline]) : deadline });
  } catch (cause) {
    if (cause instanceof Error && ['TimeoutError', 'AbortError'].includes(cause.name)) {
      throw new Error('The video service took too long to respond. Check that the server is running, then try again.');
    }
    throw new Error('Cannot reach the video service. Check that the server is running, then try again.');
  }
}
